import Icon from '@xunlei/thunder-ui-vue/lib/icon.js';
import Button from '@xunlei/thunder-ui-vue/lib/button.js';
import { isDef, promisifySync, isElectron } from '@xunlei/thunder-ui-vue/lib/utils/util.js';

var NAMESPACE = 'td';

var Dialog = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.visible, expression: "visible" }], staticClass: "td-cover" }, [_c('div', { staticClass: "td-dialog", class: [{ 'td-dialog--fullscreen': _vm.fullscreen }, _vm.customClass] }, [_c('div', { staticClass: "td-dialog__header" }, [_vm._t("header"), _vm._v(" "), _c('a', { staticClass: "td-dialog__close", attrs: { "href": "javascript:;", "title": "关闭" }, on: { "click": _vm.handleClose } }, [_c('td-icon', { attrs: { "type": "close" } })], 1)], 2), _vm._v(" "), _c('div', { staticClass: "td-dialog__body" }, [_vm._t("default")], 2), _vm._v(" "), _vm.footerEnabled ? _c('div', { staticClass: "td-dialog__footer" }, [_c('div', { staticClass: "td-dialog-footer" }, [_vm._t("footer", [_c('td-button', { on: { "click": _vm.handleOk } }, [_vm._v("确定")])])], 2), _vm._v(" "), _vm.$slots.more ? _c('a', { staticClass: "td-more-arrow", class: { 'td-more-arrow--down': _vm.moreVisible }, attrs: { "href": "javascript:;" }, on: { "click": _vm.handleMoreToggle } }, [_c('td-icon', { attrs: { "type": "arrow-drop" } })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.$slots.more && _vm.moreVisible ? _c('div', { ref: "more", staticClass: "td-dialog__more" }, [_vm._t("more")], 2) : _vm._e()])]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-dialog',
  components: {
    TdIcon: Icon,
    TdButton: Button
  },
  props: {
    customClass: [Array, Object, String],
    visible: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    beforeClose: Function,
    footerEnabled: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      moreVisible: false,
      moreHeight: 0
    };
  },
  mounted: function mounted() {
    document.body.appendChild(this.$el);
  },
  destroyed: function destroyed() {
    if (isDef(this.$el.parentNode)) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },

  methods: {
    handleClose: function handleClose() {
      var _this = this;

      promisifySync(!this.beforeClose).catch(function () {
        return _this.beforeClose();
      }).then(function () {
        _this.$emit('update:visible', false);
        _this.$emit('close');

        if (_this.fullscreen && isElectron()) {
          window.close();
        }
      });
    },
    handleOk: function handleOk() {
      this.$emit('ok');
    },
    handleMoreToggle: function handleMoreToggle() {
      var _this2 = this;

      this.moreVisible = !this.moreVisible;
      this.$emit('more-toggle', this.moreVisible);

      if (this.fullscreen && isElectron()) {
        this.$nextTick(function () {
          if (_this2.moreHeight === 0) {
            _this2.moreHeight = _this2.$refs.more.clientHeight + 30;
          }

          window.resizeBy(0, _this2.moreVisible ? _this2.moreHeight : -_this2.moreHeight);
        });
      }
    }
  }
};

var Confirm = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('td-dialog', _vm._g(_vm._b({}, 'td-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', { staticClass: "td-dialog-comfirm" }, [_c('span', { staticClass: "td-dialog-comfirm__icon" }, [_c('td-icon', { attrs: { "type": _vm.icon[_vm.type] } })], 1), _vm._v(" "), _c('div', { staticClass: "td-dialog-comfirm__content" }, [_c('p', { staticClass: "td-dialog-comfirm__title" }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', { staticClass: "td-dialog-comfirm__text" }, [_vm._t("default")], 2)])]), _vm._v(" "), _c('template', { slot: "footer" }, [_c('td-button', { on: { "click": function click($event) {
          return _vm.$emit('ok');
        } } }, [_vm._v(_vm._s(_vm.okText))]), _vm._v(" "), _c('td-button', { attrs: { "secondary": "" }, on: { "click": function click($event) {
          return _vm.$emit('cancel');
        } } }, [_vm._v(_vm._s(_vm.cancelText))])], 1)], 2);
  }, staticRenderFns: [],
  name: NAMESPACE + '-confirm',

  components: {
    TdButton: Button,
    TdDialog: Dialog
  },

  props: {
    title: String,
    type: {
      type: String,
      default: 'info'
    },
    okText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    }
  },

  data: function data() {
    return {
      icon: {
        'info': 'question',
        'warning': 'warning',
        'error': 'error'
      }
    };
  }
};

Dialog.install = function (Vue) {
  Vue.component(Dialog.name, Dialog);
  Vue.component(Confirm.name, Confirm);
};

export default Dialog;
export { Confirm };
